import React from 'react';

interface StatCardProps {
	title: string;
	value: string | number;
	subtitle?: string;
	icon?: React.ReactNode;
}

export default function StatCard({ title, value, subtitle, icon }: StatCardProps) {
	return (
		<div className="rounded-lg border border-zinc-950/5 bg-white p-6 dark:border-white/10 dark:bg-zinc-900">
			<div className="flex items-center gap-3">
				{icon && (
					<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400">
						{icon}
					</div>
				)}
				<div className="min-w-0">
					<p className="text-sm font-medium text-zinc-500 dark:text-zinc-400">{title}</p>
					<p className="mt-1 text-2xl font-semibold text-zinc-900 dark:text-white">{value}</p>
					{subtitle && (
						<p className="mt-0.5 text-xs text-zinc-500 dark:text-zinc-400">{subtitle}</p>
					)}
				</div>
			</div>
		</div>
	);
}
